module.exports = __webpack_public_path__ + "img/DSC09223 1.b74d5daa.webp";